import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'app-common-workflow-create-task',
  templateUrl: './common-workflow-create-task.component.html',
  styleUrls: ['../parts.css']
})
export class CommonWorkflowCreateTaskComponent implements OnInit {

  processList = [];
  processActivities = [];
  processParams: any; // 流程图参数
  processUrl: string; // 流程图地址
  processInstanceData: any; // 流程实例
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据

  // 流程
  processDefinitionVisible: boolean; // 流程POP是否关闭
  processDefinitionKey = null; // 流程选中ID
  processDefinitionDisplayText = '流程';
  processDefinitionOptions = [];
  selectProcessDefinition: string;

  // 流程节点
  taskDefinitionVisible: boolean; // 流程节点POP是否关闭
  taskDefinitionKey = null; // 流程节点选中ID
  taskDefinitionDisplayText = '节点';

  // 状态
  workflowTaskStateVisible: boolean; // 流程状态
  workflowTaskState = null; // 选中状态
  workflowTaskStateDisplayText = '何';
  workflowTaskStateData = [
    {
      id: 'create',
      title: '创建'
    },
    {
      id: 'complete',
      title: '完成'
    },
    // {
    //   id: 'delete',
    //   title: '删除'
    // }
  ];

  // 任务规则
  taskDefId: string; // 任务规则ID
  taskText = '任务规则';
  taskVisible = false;
  nodes = [];

  // 条件
  conditionData: any; // 存放条件筛选数据
  conditionVisible = false; // 条件pop
  selectConditionData = []; // 选中的条件
  source = 'dateCondition';
  conditionPopVisible = false;
  filterConditions = [];

  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组';
  // 其他
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipe;
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  categorieId: string; // 存放当前目录ID
  backFillData: any;
  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    taskDefId: '',
    processDefinitionKey: '',
    processDefinitionName: '',
    taskDefinitionKey: '',
    taskDefinitionName: '',
    workflowTaskState: '',
    instanceDescription: '',
    taskMapping: {},
    conditions: []
  }; // 存放入参数据
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
    }
    // 处理返填数据
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.backFillData = this.automation.taskMapping;
      this.processDefinitionKey = this.automation.processDefinitionKey;
      this.selectProcessDefinition = this.automation.processDefinitionKey;
      this.processDefinitionDisplayText = this.automation.processDefinitionName;
      this.taskDefinitionKey = this.automation.taskDefinitionKey;
      this.taskDefinitionDisplayText = this.automation.taskDefinitionName;
      this.workflowTaskState = this.automation.workflowTaskState;
      if (this.selectProcessDefinition) {
        this.queryProcessActivityNodeData();
      }
      this.workflowTaskStateData.forEach(_w => {
        if (_w.id === this.workflowTaskState) {
          this.workflowTaskStateDisplayText = _w.title;
        }
      });
      this.taskDefId = this.automation.taskDefId;
      this.groupConditionId = this.automation.groupId;
      for (const item of this.boardGroupData) {
        if (item.id === this.groupConditionId) {
          this.groupConditionDisplayText = item.title;
          break;
        }
      }
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    this.filterConditions = this.automation.conditions;
    this.packageData();
    this.getTaskRuleListData();
    this.queryCategoryProcessData();
  }
  // 查询流程列表
  queryCategoryProcessData() {
    this.taskService.queryCategoryProcess().subscribe((res: any) => {
      res.forEach((item) => {
        item['value'] = item.category;
        item['label'] = item.categoryName;
        if (item.processList) {
          item['children'] = item.processList;
          item['children'].forEach(_child => {
            _child['value'] = _child.procDefKey;
            _child['label'] = _child.name;
            _child['isLeaf'] = true;
          });
        }
        this.processDefinitionOptions.push(item);
      });
    });
  }
  queryProcessActivities() {
    if (this.recipe && this.recipe['queryProcessActivities']) {
      this.taskService.queryProcessActivities(this.processDefinitionKey, this.recipe['queryProcessActivities']).subscribe((res: any) => {
        if (res) {
          this.processActivities = res;
        } else {
          this.message.error('查询流程节点异常');
        }
      });
    } else {
      this.message.info('为配置流程节点信息查询接口，请联系管理员！');
    }
  }

  // 分组变更
  groupConditionChange(item) {
    this.groupConditionDisplayText = item.title;
    this.groupConditionId = item.id;
    this.automation.groupId = item.id;
    this.groupConditionVisible = false;
    this.packageData();
  }
  // 流程状态变更
  workflowTaskStateChange(state) {
    this.workflowTaskStateDisplayText = state.title;
    this.workflowTaskState = state.id;
    this.workflowTaskStateVisible = false;
    this.automation.workflowTaskState = this.workflowTaskState;
    this.packageData();
  }
  // 弹窗创建任务
  openTaskDialog() {
    this.isVisible = true;
  }

  // 弹窗确定事件
  handleOk() {
    this.pulseCard.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    // this.backFillData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
            break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping['mappingConfig'] = obj;
    });
    this.packageData();
  }
  // 组件提交数据
  packageData() {
    this.automation.instanceDescription = '监听到 ' + this.processDefinitionDisplayText + ' 的节点 ' + this.taskDefinitionDisplayText + '为' + this.workflowTaskStateDisplayText + '时，且满足条件，根据任务规则，在' + this.groupConditionDisplayText + '中，创建任务';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.processDefinitionKey &&
      this.taskDefinitionKey &&
      this.groupConditionId &&
      JSON.stringify(this.automation.taskMapping) !== '{}';
  }
  onTaskChange($event) {
    this.automation.taskDefId = $event;
    this.taskVisible = false;
    this.packageData();
  }
  // 获取任务规则列表
  getTaskRuleListData() {
    this.taskService.getManualTaskData(this.boardGroupData[0].boardId).subscribe((res: any) => {
      const data = res && res._embedded ? res._embedded.vos : [];
      this.nodes = this.listConvertTree(data);
      this.nodes = this.handleTreeData(this.nodes);
      this.taskDefId = this.automation.taskDefId;
    });
  }
  // 平级转树形数据
  listConvertTree(data) {
    // 没有父节点的数据
    const parents = data.filter(value => value.parentId === 'undefined' || value.parentId == null);
    // 有父节点的数据
    const children = data.filter(value => value.parentId !== 'undefined' && value.parentId != null);
    const translator = (parents, children) => {
      // 遍历父节点数据
      parents.forEach((parent) => {
          // 遍历子节点数据
          children.forEach((current, index) => {
              // 此时找到父节点对应的一个子节点
              if (current.parentId === parent.id) {
                // 对子节点数据进行深复制，这里只支持部分类型的数据深复制
                const temp = JSON.parse(JSON.stringify(children));
                // 让当前子节点从temp中移除，temp作为新的子节点数据，这里是为了让递归时，子节点的遍历次数更少，如果父子关系的层级越多，越有利
                temp.splice(index, 1);
                // 让当前子节点作为唯一的父节点，去递归查找其对应的子节点
                translator([current], temp);
                // 把找到子节点放入父节点的children属性中
                if (parent.children && parent.children.length) {
                  parent.children.push(current);
                } else {
                  parent.children = [current];
                }
                // typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current];
              }
            }
          );
        }
      );
    };
    translator(parents, children);
    return parents;
  }
  handleTreeData(data) {
    data.forEach(item => {
      item.title = item.name;
      item.key = item.id;
      if (item.children && item.children.length) {
        this.handleTreeData(item.children);
      } else {
        item.isLeaf = true;
      }
    });
    return data;
  }
  conditionPopChange() {
    if (!this.conditionPopVisible) {
      this.automation.conditions = this.filterConditions;
      this.packageData();
    }
  }
  onProcessDefinitionChanges(event) {
    this.processDefinitionOptions.forEach(item => {
      if (item.children) {
        item.children.forEach(child => {
          if (child.procDefKey === event[1]) {
            this.processDefinitionDisplayText = child.name;
          }
        });
      }
    });
    this.selectProcessDefinition = event[1];
    this.processParams = {
      processDefinitionId: '',
      processInstanceId: '',
      processDefinitionKey: this.selectProcessDefinition,
      applicationName: 'workflow'
    };
    this.processUrl = '/workflow/api/workflow/process/get_bpmn?processDefinitionKey=' + this.selectProcessDefinition;
    if (this.selectProcessDefinition) {
      this.queryProcessActivityNodeData();
    }
    this.processDefinitionVisible = false;
    this.automation.processDefinitionKey = this.selectProcessDefinition;
    this.automation.processDefinitionName = this.processDefinitionDisplayText;
    this.packageData();
  }
  queryProcessActivityNodeData() {
    const param = {
      processDefinitionKey: this.selectProcessDefinition
    };
    this.taskService.queryProcessActivityNode(param).subscribe((res: any) => {
      if (res) {
        this.processInstanceData = res.data;
      }
    });
  }
  openProcessNodeDialog() {
    if (this.processDefinitionKey) {
      this.taskDefinitionVisible = true;
    } else {
      this.message.warning('请先选择流程！');
    }
  }
  handleTaskDefinitionCancel() {
    this.taskDefinitionVisible = false;
  }
  taskDefinitionChange(event) {
    if (event) {
      this.taskDefinitionVisible = false;
      this.taskDefinitionDisplayText = event.taskName;
      this.taskDefinitionKey = event.taskDefinitionKey;
      this.automation.taskDefinitionKey = this.taskDefinitionKey;
      this.automation.taskDefinitionName = this.taskDefinitionDisplayText;
      this.packageData();
    }
  }
}
